import React from "react";
import { Card } from "@/components/ui/card";

export const SignUpWelcome = () => {
  return (
    <div className="space-y-8 max-w-4xl mx-auto">
      {/* Header Section */}
      <div className="text-center space-y-4">
        <img 
          src="/Maia_horizontal_color.svg" 
          alt="Maia Logo" 
          className="h-16 w-auto mx-auto"
        />
        <h1 className="text-3xl font-bold">Welcome to Maia Email Assistant</h1>
        <p className="text-xl text-muted-foreground">
          Your AI-powered email assistant for Gmail with Human in the Loop
        </p>
      </div>

      {/* Call to Action */}
      <div className="text-center space-y-4">
        <p className="text-lg text-muted-foreground">
          Account creation is limited in Beta untill google certification is complete!
        </p>
      </div>
    </div>
  );
};
